import React from 'react'
import { OFFER_TYPE_CRUISE } from 'constants/offer'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import PaneBody from 'components/Common/Pane/PaneBody'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import useOfferList from 'hooks/Offers/useOfferList'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

interface Props {
  filters: App.OfferListFilters
}

function CruiseDealRecommendations({ filters }: Props) {
  const offerList = useOfferList({
    offerTypes: [OFFER_TYPE_CRUISE],
    ...filters,
  })

  if (!offerList.offerIds.length) {
    return null
  }

  return <Pane>
    <PaneBody>
      <Group gap={24} direction="vertical">
        <LayoutContainer>
          <Heading variant="heading2">You may also like</Heading>
        </LayoutContainer>

        <OfferListCarousel overrideOfferList={offerList} tileStyle="card-default" tileSize="medium" />
      </Group>
    </PaneBody>
  </Pane>
}

export default CruiseDealRecommendations
